import * as bootstrap from 'bootstrap';

document.addEventListener('DOMContentLoaded', function() {
  "use strict";

  // Smooth scrolling
  document.querySelectorAll('a.js-scroll-trigger[href*="#"]:not([href="#"])').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const hash = this.getAttribute('href');
      const target = document.querySelector(hash);
      if (target) {
        e.preventDefault();
        const offsetTop = target.offsetTop - 54;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    });
  });

  // Close responsive menu when a scroll trigger link is clicked
  document.querySelectorAll('.js-scroll-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const navbarCollapse = document.querySelector('.navbar-collapse');
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse);
        if (bsCollapse) {
          bsCollapse.hide();
        }
      }
    });
  });

  // Navbar shrink on scroll
  const mainNav = document.getElementById('mainNav');
  function navbarShrink() {
    if (window.scrollY > 100) {
      mainNav.classList.add('navbar-shrink');
    } else {
      mainNav.classList.remove('navbar-shrink');
    }
  }

  navbarShrink();
  window.addEventListener('scroll', navbarShrink);
});
